import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import { Button, Container, Row } from "reactstrap";
import SelectPRO from 'react-select';
import { appUrl } from '../../config';
import { DialogTitle, Dialog, DialogActions, DialogContent, Typography, Grid, CardActionArea } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import CardActions from '@material-ui/core/CardActions';
import User from '@material-ui/icons/AccountCircle';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';



// core components
class Examples extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      auxlisttopics: [],
      topicselected: {},
      quesfromtopic: [],
      top10:[],
      open:false,
      questionselected:[]
    }
  }

  componentDidMount() {
    this.getTopics()
    this.getAllques()
  }
  getAllques = () => {
    fetch(appUrl + '/getques', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var limitques = []
          var top10=[]
          if (data.questions.length >= 3) {
            for (var i = 0; i < 3; i++) {
              limitques.push(data.questions[i])
            }
          } else {
            for (var i = 0; i < data.questions.length; i++) {
              limitques.push(data.questions[i])
            }
          }
          if(data.questions.length>=6){
            for (var i = 0; i < 6; i++) {
              top10.push({value:(i+1)+".  ",descorta:data.questions[i].descorta,deslarga:data.questions[i].deslarga,respuesta:data.questions[i].respuesta})
            }  
          }else{
            for (var i = 0; i < data.questions.length; i++) {
              top10.push({value:(i+1)+".  ",descorta:data.questions[i].descorta,deslarga:data.questions[i].deslarga,respuesta:data.questions[i].respuesta})
            }  
          }
        this.setState({ quesfromtopic: limitques, top10:top10 })
        } else {
          //console.log("Error")
        }
      });
  }
  getTopics = () => {
    fetch(appUrl + '/gettopics', {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log(data)
          var auxlisttopics = []
          for (var i = 0; i < data.topics.length; i++) {
            auxlisttopics.push({ value: data.topics[i]._id, label: data.topics[i].name })
          }
          this.setState({ topics: data.topics, auxlisttopics: auxlisttopics })
          console.log("auxlisttopics", auxlisttopics)
        } else {
          //console.log("Error")
        }
      });
  }
  handleChange = selectedOption => {
    console.log(`Option selected:`, selectedOption);
    this.setState({ topicselected: selectedOption });
    fetch(appUrl + '/getansfromtopic', {
      method: 'post',
      body: JSON.stringify({
        topic: selectedOption.value,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log("Answers");
          var limitques = []
          if (data.questions.length >= 3) {
            for (var i = 0; i < 3; i++) {
              limitques.push(data.questions[i])
            }
          } else {
            for (var i = 0; i < data.questions.length; i++) {
              limitques.push(data.questions[i])
            }
          }
          this.setState({ quesfromtopic: limitques })
        } else {
          console.log("No answers")
          this.setState({ quesfromtopic: [] })
        }
      });
  };
  handleClickOpen = (event, ques) => {
    console.log(ques)
    this.setState({ open: true , questionselected:ques});
  }

  handleClose = () => {
    this.setState({ open: false });
  }
   handleClick = (event, view) => {
    this.props.onChange("view", view);
  }
  render() {
    return (
      <>
        <div className="section section-examples" data-background-color="gray">
          <Container className="text-center">
            <br></br>
            <Typography variant="h2" component="h3" gutterBottom>
              ¿Tienes preguntas?
      </Typography>
            <Row>
              <div className="col">
                <Typography variant="h5" component="h4" gutterBottom>
                  Selecciona una categoría
              </Typography>
                <SelectPRO
                  value={this.state.topicselected}
                  onChange={this.handleChange}
                  options={this.state.auxlisttopics}
                  fullWidth />
                <div style={{ marginTop: 4 }}>
                  <Grid
                    container
                    spacing={1}
                  >
                    {this.state.quesfromtopic.map(list => (
                      <Grid
                        item
                        xs={12}
                      >
                        <Card
                        >
                          <CardActionArea onClick={event => this.handleClickOpen(event, list)}>
                            <CardContent>
                              <Typography
                                align="center"
                                variant="h6"
                              >
                                {list.descorta}
                              </Typography>
                            </CardContent>
                                      <Typography
                                align="center"
                                variant="p"
                              >
                                {list.respuesta.substr(0,30)+"..."}
                              </Typography>
                            <Divider />
                            <CardActions>
                              <Grid
                                container
                                justify="space-between"
                              >
                                <Grid
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                  item
                                >
                                  <HelpOutlineIcon />
                                  <Typography
                                    display="inline"
                                    variant="body1"
                                  >
                                    Ver más...
                                  </Typography>
                                </Grid>

                              </Grid>
                            </CardActions>
                          </CardActionArea>
                        </Card>
                      </Grid>

                    ))}

                  </Grid>
                </div>
              </div>
              <div className="col">
              <br></br>
                <Typography variant="h5" component="h4" gutterBottom>
                  <CheckCircleOutlineIcon /> TOP Preguntas frecuentes:
              </Typography>
                <div style={{ marginTop: 4 }}>
                  <Grid
                    container
                    spacing={1}
                  >
                    {this.state.top10.map(ques => (
                      <ListItem button onClick={event => this.handleClickOpen(event, ques)}>
                        <Typography variant="h5" component="h4">
                        {ques.value}
                       </Typography> 
                       <ListItemText primary={ques.descorta} secondary={ques.respuesta.substr(0,40)+"..."} style={{marging:10}} />
                       <NavigateNextIcon /> 
                      </ListItem>
                    ))}
                  </Grid>
                </div>
              </div>
            </Row>
            <Button
              className="btn-round"
              color="default"
              onClick={event => this.handleClick(event, "allquestions")}
              outline

            >
              IR AL TODAS LA PREGUNTAS
              </Button>
              <Dialog
              open={this.state.open}
              onClose={this.handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              minWidth="1000px"
            >
              <DialogContent>
              <Typography variant="h3" component="h4">
              {this.state.questionselected.deslarga}
                </Typography> 
                <Divider/>
                <Typography variant="h4" component="h5">
              {this.state.questionselected.respuesta}
                </Typography> 
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary" autoFocus>
                  Cerrar
                </Button>
              </DialogActions>
            </Dialog>
          </Container>
          
        </div>
      </>
    );
  }
}
export default Examples;
